export default __webpack_public_path__ + "static/game-theory-desktop-hold-15222c49d6e1f6a30cd7e4115d391f3f.svg";